import React, { useState } from "react";
import "./ClubListStyle.css";
import PrimaryButton from "../../../components/globalComponents/buttons/primaryButton/PrimaryButton";
import PrimaryButtonImg from "../../../components/globalComponents/buttons/primaryButtonImg/PrimaryButtonImg";
import { useNavigate } from "react-router-dom";

const ClubList = () => {
  const [showTable, setShowTable] = useState(true);
  const navigate = useNavigate();
  return (
    <div className="clubListContainer">
      <div className="pageHeader">
        <p className="componentHeading"></p>
        <div className="pageTogglers">
          <div
            className={`pageToggler ${showTable ? "active" : ""}`}
            onClick={() => setShowTable(true)}
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.83333 4.79163C1.71827 4.79163 1.625 4.8849 1.625 4.99996C1.625 5.11502 1.71827 5.20829 1.83333 5.20829C1.94839 5.20829 2.04167 5.11502 2.04167 4.99996C2.04167 4.8849 1.94839 4.79163 1.83333 4.79163ZM0.375 4.99996C0.375 4.19454 1.02792 3.54163 1.83333 3.54163C2.63875 3.54163 3.29167 4.19454 3.29167 4.99996C3.29167 5.80537 2.63875 6.45829 1.83333 6.45829C1.02792 6.45829 0.375 5.80537 0.375 4.99996ZM5.375 4.99996C5.375 4.65478 5.65482 4.37496 6 4.37496L16 4.37496C16.3452 4.37496 16.625 4.65478 16.625 4.99996C16.625 5.34514 16.3452 5.62496 16 5.62496L6 5.62496C5.65482 5.62496 5.375 5.34514 5.375 4.99996ZM1.83333 9.79163C1.71827 9.79163 1.625 9.8849 1.625 9.99996C1.625 10.115 1.71827 10.2083 1.83333 10.2083C1.94839 10.2083 2.04167 10.115 2.04167 9.99996C2.04167 9.8849 1.94839 9.79163 1.83333 9.79163ZM0.375 9.99996C0.375 9.19454 1.02792 8.54163 1.83333 8.54163C2.63875 8.54163 3.29167 9.19454 3.29167 9.99996C3.29167 10.8054 2.63875 11.4583 1.83333 11.4583C1.02792 11.4583 0.375 10.8054 0.375 9.99996ZM5.375 9.99996C5.375 9.65478 5.65482 9.37496 6 9.37496L16 9.37496C16.3452 9.37496 16.625 9.65478 16.625 9.99996C16.625 10.3451 16.3452 10.625 16 10.625L6 10.625C5.65482 10.625 5.375 10.3451 5.375 9.99996ZM1.83333 14.7916C1.71827 14.7916 1.625 14.8849 1.625 15C1.625 15.115 1.71827 15.2083 1.83333 15.2083C1.94839 15.2083 2.04167 15.115 2.04167 15C2.04167 14.8849 1.94839 14.7916 1.83333 14.7916ZM0.375 15C0.375 14.1945 1.02792 13.5416 1.83333 13.5416C2.63875 13.5416 3.29167 14.1945 3.29167 15C3.29167 15.8054 2.63875 16.4583 1.83333 16.4583C1.02792 16.4583 0.375 15.8054 0.375 15ZM5.375 15C5.375 14.6548 5.65482 14.375 6 14.375L16 14.375C16.3452 14.375 16.625 14.6548 16.625 15C16.625 15.3451 16.3452 15.625 16 15.625L6 15.625C5.65482 15.625 5.375 15.3451 5.375 15Z"
                fill="#262626"
              />
            </svg>
            Club List
          </div>
          <div
            className={`pageToggler ${!showTable ? "active" : ""}`}
            onClick={() => setShowTable(false)}
          >
            <svg
              width="21"
              height="20"
              viewBox="0 0 21 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.97325 1.875H14.0268C14.7041 1.87499 15.2505 1.87499 15.6929 1.91114C16.1484 1.94835 16.5485 2.02699 16.9187 2.2156C17.5067 2.51521 17.9848 2.99327 18.2844 3.58128C18.473 3.95146 18.5516 4.35158 18.5889 4.80711C18.625 5.24953 18.625 5.79587 18.625 6.47323V11.0268C18.625 11.7041 18.625 12.2505 18.5889 12.6929C18.5516 13.1484 18.473 13.5485 18.2844 13.9187C17.9848 14.5067 17.5067 14.9848 16.9187 15.2844C16.5485 15.473 16.1484 15.5516 15.6929 15.5889C15.2505 15.625 14.7041 15.625 14.0268 15.625H11.9031C11.358 15.625 11.1722 15.6279 11 15.6633C10.8345 15.6972 10.6744 15.7534 10.5239 15.8303C10.3674 15.9102 10.2204 16.0241 9.79478 16.3646L7.78762 17.9703C7.63101 18.0956 7.48183 18.215 7.35283 18.3003C7.22821 18.3827 7.01748 18.5078 6.75112 18.5081C6.43389 18.5084 6.1338 18.3642 5.93589 18.1163C5.76973 17.9081 5.73579 17.6654 5.72227 17.5166C5.70829 17.3626 5.70831 17.1715 5.70833 16.971L5.70833 15.6228C5.29807 15.6168 4.97756 15.5953 4.69119 15.5185C3.61278 15.2296 2.77044 14.3872 2.48148 13.3088C2.3746 12.9099 2.37475 12.4448 2.37498 11.7632C2.37499 11.7315 2.375 11.6993 2.375 11.6667L2.375 6.47325C2.37499 5.79588 2.37499 5.24953 2.41114 4.80711C2.44835 4.35158 2.52699 3.95146 2.7156 3.58128C3.01521 2.99327 3.49327 2.51521 4.08128 2.2156C4.45146 2.02699 4.85158 1.94835 5.30711 1.91114C5.74953 1.87499 6.29588 1.87499 6.97325 1.875ZM5.4089 3.15699C5.03067 3.18789 4.81336 3.2455 4.64877 3.32936C4.29596 3.50913 4.00912 3.79596 3.82936 4.14877C3.7455 4.31337 3.68789 4.53067 3.65698 4.9089C3.62549 5.29443 3.625 5.78962 3.625 6.5V11.6667C3.625 12.4819 3.63037 12.7669 3.68889 12.9853C3.86226 13.6323 4.36767 14.1377 5.01471 14.3111C5.23312 14.3696 5.51812 14.375 6.33333 14.375C6.67851 14.375 6.95833 14.6548 6.95833 15V16.9462C6.95833 16.9768 6.95834 17.0056 6.95838 17.0328C6.97966 17.0159 7.00217 16.9979 7.02603 16.9788L9.01391 15.3885C9.0298 15.3758 9.04548 15.3632 9.06095 15.3508C9.42181 15.062 9.6717 14.862 9.95523 14.7171C10.206 14.589 10.4729 14.4954 10.7487 14.4388C11.0606 14.3748 11.3807 14.3749 11.8429 14.375C11.8627 14.375 11.8828 14.375 11.9031 14.375H14C14.7104 14.375 15.2056 14.3745 15.5911 14.343C15.9693 14.3121 16.1866 14.2545 16.3512 14.1706C16.704 13.9909 16.9909 13.704 17.1706 13.3512C17.2545 13.1866 17.3121 12.9693 17.343 12.5911C17.3745 12.2056 17.375 11.7104 17.375 11V6.5C17.375 5.78962 17.3745 5.29443 17.343 4.9089C17.3121 4.53067 17.2545 4.31337 17.1706 4.14877C16.9909 3.79596 16.704 3.50913 16.3512 3.32936C16.1866 3.2455 15.9693 3.18789 15.5911 3.15699C15.2056 3.12549 14.7104 3.125 14 3.125H7C6.28962 3.125 5.79443 3.12549 5.4089 3.15699Z"
                fill="#262626"
              />
            </svg>
            Club Response
          </div>
        </div>
        <div>
          <PrimaryButtonImg
            onClick={() => navigate("/createclub")}
            classname={"primaryBtn"}
            children={"Create"}
            img={"../assets/icons/message-question-square-sml.svg"}
          />
        </div>
      </div>
      <div className="filterBar">
        <div className="searchBox">
          <img src="../assets/icons/search-sm.svg" alt="" />
          <input type="text" className="searchInput" placeholder="Search ..." />
        </div>
        <button className="fiterBtn">
          {" "}
          <img src="../assets/icons/filter-lines.svg" alt="" /> Filters
        </button>
      </div>
      <div className="clubListTableContainer">
        {/* <div className="emptyTableBox">
                    <img src="../assets/img/User05c.png" alt="" />
                    <h3 className="heading">Create a Club</h3>
                    <p className="text">You have created a new club. Now you can conduct club related activities.</p>
                </div> */}
        {showTable ? (
          <table className="clubListTable" cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Club Name</th>
                <th>President Name</th>
                <th>Club Type</th>
                <th>Events</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Music Club</td>
                <td>Anand Krishnan</td>
                <td>Anand Krishnan</td>
                <td>
                  <p>
                    <span className="primaryText">4 Upcoming</span>{" "}
                    <span className="dangerText">5 Past</span>
                  </p>{" "}
                </td>
                <td>
                  {" "}
                  <PrimaryButton
                    classname={"successSecondaryBtnSmall"}
                    children={"Club details"}
                  />{" "}
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <table className="clubListTable" cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Club Name</th>
                <th>Club Type</th>
                <th>Response</th>
                <th>Comments</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Music Club</td>
                <td>Sports</td>
                <td>
                  <p className="successTag">Approved</p>
                </td>
                <td>
                  {" "}
                  <PrimaryButton
                    classname={"darkSecondaryOutlineBtnSmall"}
                    children={"View"}
                  />{" "}
                </td>
              </tr>
              <tr>
                <td>Music Club</td>
                <td>Sports</td>
                <td>
                  <p className="dangerTag">Rejected</p>
                </td>
                <td>
                  {" "}
                  <PrimaryButton
                    classname={"darkSecondaryOutlineBtnSmall"}
                    children={"View"}
                  />{" "}
                </td>
              </tr>
              <tr>
                <td>Music Club</td>
                <td>Sports</td>
                <td>
                  <p className="primaryTag">Pending</p>
                </td>
                <td>
                  {" "}
                  <PrimaryButton
                    classname={"darkSecondaryOutlineBtnSmall"}
                    children={"View"}
                  />{" "}
                </td>
              </tr>
              <tr>
                <td>Music Club</td>
                <td>Sports</td>
                <td>
                  <p className="primaryTag">Pending</p>
                </td>
                <td>
                  {" "}
                  <PrimaryButton
                    classname={"darkSecondaryOutlineBtnSmall"}
                    children={"View"}
                    isdisabled={true}
                  />{" "}
                </td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ClubList;
